import { useEffect } from 'react';

/**
 * КАКИЕ ДИАЛОГИ СЕЙЧАС ОТКРЫТЫ НА ЭТОМ ЭКРАНЕ (`s720`): «не дублировать активный видимый диалог».
 * Переписка, открытая в «Переписках», в карточке лида или в окне записи, отмечает себя здесь, пока
 * стоит на экране. Вкладка не на виду (свёрнута, перекрыта другой вкладкой) — видимых диалогов нет:
 * человек её не видит, и уведомление по этой переписке нужно.
 */
const otkrytye = new Map<number, number>();

export function vidimyeSeychas(): Set<number> {
  if (typeof document !== 'undefined' && document.visibilityState !== 'visible') return new Set();

  return new Set(otkrytye.keys());
}

export function useVidimyyDialog(id: number | undefined, vklyuchyon = true): void {
  useEffect(() => {
    if (id === undefined || !vklyuchyon) return;
    otkrytye.set(id, (otkrytye.get(id) ?? 0) + 1);

    return () => {
      const ostalos = (otkrytye.get(id) ?? 1) - 1;
      if (ostalos <= 0) otkrytye.delete(id);
      else otkrytye.set(id, ostalos);
    };
  }, [id, vklyuchyon]);
}
